import React from "react";
import { CustomerRow } from "./CustomerTable";
import { CustomerSortTypes } from "../../../configs/sortTypes";
import { CustomerFilterType } from "../../../configs/filterTypes";
import ListView from "../../../shared/components/ListView";
import { CustomerTableColumns, Search } from "../../../configs/customer";

const Content = () => {
    return (
        <ListView
            url="/customers/"
            sortTypes={CustomerSortTypes}
            filterTypes={CustomerFilterType}
            rowElement={CustomerRow}
            tableColumns={CustomerTableColumns}
            textString={Search.searchText}
        />
    );
};

export default Content;
